<template>
  <div class="flex flex-col gap-2">
    <select-container
      title="עריכת עיצוב הטופס"
      icon="pi-pencil"
      :no-border="true"
      @click="onEdit"
    />
    <select-container
      title="מילוי וחתימה"
      subtitle="נסו את הטופס בעצמכם לפני שאתם שולחים ללקוחות"
      icon="pi-send"
      :no-border="true"
      @click="onFill"
    />
    <select-container
      title="העתקת קישור לשיתוף"
      icon="pi-send"
      :no-border="true"
      @click="onCopyLink"
    />
    <select-container
      title="מחיקת טופס"
      icon="pi-trash"
      :no-border="true"
      @click="onDelete"
      bg="red"
      last-item
    />

  </div>
</template>

<script setup lang="ts">
import { IConsentForm } from '@torim-app/types';
import { SelectContainer } from '@torim-app/shared-components';

const props = defineProps<{
  form: IConsentForm;
  onEdit: () => void;
  onFill: () => void;
  onCopyLink: () => void;
  onDelete: () => void;
}>();
</script>
